import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import type { IqeProject } from '../../../interfaces/ui';
import { useStyles } from '../../../styles';
import '../../../styles/regenerateConfirmDialog.css';

interface RegenerateConfirmDialogProps {
  isOpen: boolean;
  project: IqeProject | undefined;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RegenerateConfirmDialog = ({
  isOpen,
  project,
  onConfirm,
  onCancel,
}: RegenerateConfirmDialogProps) => {
  const classes = useStyles();

  const currentVersionCount = project?.runs?.length || 0;
  const newVersionCount = currentVersionCount + 1;

  return (
    <Dialog
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="regenerate-dialog-title"
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: classes.regenerateDialogPaper }}
    >
      <DialogTitle id="regenerate-dialog-title" disableTypography>
        <Typography variant="h6" className="rcd-title">
          Regenerate Test Suite
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography className="rcd-message">
          This action will create a new version of the test plan and regenerate
          all test cases based on the current application state.
        </Typography>

        <Box className="rcd-version-info-box">
          <Box className="rcd-version-row">
            <Typography component="span">Current Version:</Typography>
            <Typography component="span" className="rcd-version-value">
              v{currentVersionCount}
            </Typography>
          </Box>
          <Box className="rcd-version-row">
            <Typography component="span">New Version:</Typography>
            <Typography component="span" className="rcd-version-value">
              v{newVersionCount}
            </Typography>
          </Box>
        </Box>

        <Typography className="rcd-note">
          Existing execution history will remain available.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onCancel}
          variant="outlined"
          aria-label="Cancel regeneration"
          className="rcd-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          aria-label="Confirm test plan regeneration"
          className="rcd-confirm-btn"
        >
          Create New Version
        </Button>
      </DialogActions>
    </Dialog>
  );
};
